export const RESIDENCY_ROUTE_NAMES_NEW = {
  LIST: 'residencyListNew',
  DETAIL: 'residencyDetailNew',
}
